import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'

const SubsectionTitle = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          small: { bundledCSS: smallHeadingCSS },
        },
      },
      colors: { strokeSport },
      spacing: { spacing2, spacing8 },
    },
  }) => css`
    ${smallHeadingCSS};
    text-transform: uppercase;
    border-left: ${spacing2} solid ${strokeSport};
    padding-left: ${spacing8};
  `}
`

const InfoText = styled.div`
  ${({
    theme: {
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadCSS },
          large1: { bundledCSS: large1HeadingCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    ${small1SubheadCSS};
    ${desktopCSS(css`
      ${large1HeadingCSS};
    `)};
    color: ${textDefault};
    text-wrap: wrap;
  `}
`

const InfoCategoryHeader = styled.div`
  ${({
    theme: {
      typography: {
        subheads: {
          xsmall2: { bundledCSS: xsmall2SubheadCSS },
        },
      },
      colors: { textWeak },
      utils: { ellipsis },
    },
  }) => css`
    ${xsmall2SubheadCSS};
    color: ${textWeak};
    ${ellipsis('100%', 1)};
  `}
`
const SubsectionWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing16 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing16};
  `}
`

export { SubsectionTitle, InfoText, InfoCategoryHeader, SubsectionWrapper }
